import * as React from "react";

import {USER_COLOR_KEY} from "../constants";

const useColorHandler = (initialState: string) => {
  const [color, setColor] = React.useState(initialState);

  const setColorStatus = (color: string) => {
    if (color === "") {
      window.localStorage.removeItem(USER_COLOR_KEY);
    } else {
      window.localStorage.setItem(USER_COLOR_KEY, color);
    }

    setColor(color);
  };

  return {
    color,
    setColorStatus
  };
};

export default useColorHandler;
